module.exports = __webpack_public_path__ + "doctor_2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_2.jpg
// module id = 889
// module chunks = 0